module.exports = __webpack_public_path__ + "static/img/gxg_01.3fe3214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_01.png
// module id = GYK/
// module chunks = 46